import axios from 'axios';

export default () => {
    return axios.create({
        baseURL: window.apiUrl,
        withCredentials: false,
        //headers: {
        //    'Content-Type': 'multipart/form-data',
        //}
    })
}